export default __webpack_public_path__ + "static/suhack-text1-0074f816d64e33733e08c202dd640d11.png";